<template>
    <div
        class="flex flex-col items-center justify-center"
        :style="{ height: `${height}px`, gap: `${cardGap}px` }"
    >
        <KillerPlayerCard
            v-for="player in players"
            :key="player.id"
            :name="player.tag_name"
            :avatar="player.avatar"
            :color="player.color"
            :icon="icon"
            :style="{ width: `${cardWidth}px` }"
        />
    </div>
</template>

<script>
import KillerPlayerCard from './KillerPlayerCard.vue'

const CARD_ASPECT = 175 / 105
const GAP_RATIO = 0.155

export default {
    name: 'KillerPlayerCardList',
    components: { KillerPlayerCard },
    props: {
        players: {
            type: Array,
            required: true,
        },
        icon: {
            type: String,
            default: 'cross',
        },
        maxCardWidth: {
            type: Number,
            required: true,
        },
        height: {
            type: Number,
            required: true,
        },
    },
    computed: {
        cardHeight() {
            const count = Math.max(1, this.players.length)
            const fittedHeight = this.height / (count + GAP_RATIO * (count - 1))
            return Math.min(this.maxCardWidth / CARD_ASPECT, fittedHeight)
        },
        cardWidth() {
            return this.cardHeight * CARD_ASPECT
        },
        cardGap() {
            return this.cardHeight * GAP_RATIO
        },
    },
}
</script>
